import { useState } from 'react';
import { Tag } from '../../../../types';
import { useTagsContext } from '../context/TagsContext';

export const useTags = () => {
    const { tags, loading, createTag, updateTag, deleteTag, deleteBulk: contextDeleteBulk, refreshTags } = useTagsContext();
    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

    const toggleSelection = (id: string) => {
        setSelectedIds(prev => {
            const newSet = new Set(prev);
            if (newSet.has(id)) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            return newSet;
        });
    };

    const toggleAllSelection = (filteredTags: Tag[]) => {
        if (selectedIds.size === filteredTags.length && filteredTags.length > 0) {
            setSelectedIds(new Set());
        } else {
            setSelectedIds(new Set(filteredTags.map(t => t.id)));
        }
    };

    const clearSelection = () => {
        setSelectedIds(new Set());
    };

    const deleteBulk = async (ids: string[]) => {
        await contextDeleteBulk(ids);
        setSelectedIds(new Set());
    };

    const handleDeleteTag = async (id: string) => {
        await deleteTag(id);
        if (selectedIds.has(id)) {
            setSelectedIds(prev => {
                const newSet = new Set(prev);
                newSet.delete(id);
                return newSet;
            });
        }
    };

    return {
        tags,
        loading,
        createTag,
        updateTag,
        deleteTag: handleDeleteTag,
        deleteBulk,
        selectedIds,
        toggleSelection,
        toggleAllSelection,
        clearSelection,
        refetch: refreshTags
    };
};

